module.exports = __webpack_public_path__ + "img/star.42255774.png";